/**
 * Utility function to create conversation UID
 */
export function conversationUId(targetId: string, interlocutorId: string): string {
  return `${targetId}-${interlocutorId}`;
}
